import mixpanel from 'mixpanel-browser';
import { createAction, handleActions } from 'redux-actions';
import Agent from '../../api/Agent';
import { handleError } from '../user';
import mixpanelConstants from '../../constants/mixpanel';
import timesheetConstants from '../../constants/timesheetStatus';

export const setTimesheetList = createAction('SET_TIMESHEETS');
export const setTimesheetDisplayState = createAction('SET_TIMESHEET_DISPLAY_STATE');
export const resetTimesheetList = createAction('RESET_TIMESHEETS');
export const setShiftPageNumber = createAction('SET_SHIFT_PAGE_NUMBER');
export const setShiftSort = createAction('SET_SORT');
export const setShiftSortOrder = createAction('SET_SORT_ORDER');
export const setShiftIdFilter = createAction('SET_TIMESHEET_SHIFT_ID');
export const setTimesheetNurseFilter = createAction('SET_TIMESHEET_NURSE');
export const setTimesheetTimeZoneFilter = createAction('SET_TIMESHEET_TIMEZONE');
export const setStatusFilter = createAction('SET_SHIFT_STATUS_FILTER');
export const setOrgFilter = createAction('SET_ORG_FILTER');
export const setLocFilter = createAction('SET_LOC_FILTER');
export const setDeptFilter = createAction('SET_DEPT_FILTER');
export const setRoleFilter = createAction('SET_ROLE_FILTER');
export const setStatCashFilter = createAction('SET_STATCash_FILTER');
export const setFromDateFilter = createAction('SET_FORM_DATE_FILTER');
export const setToDateFilter = createAction('SET_TO_DATE_FILTER');
export const setSupervisorIdFilter = createAction('SET_SUPREVISOR_ID_FILTER');
export const setCancelReason = createAction('SET_TO_CANCEL_REASON_FILTER');
export const setSupervisorList = createAction('SET_SUPERVISOR_LIST');
export const setMessage = createAction('SET_MESSAGE');
export const setSort_ndp = createAction('SET_SORT_NDP');

const initialState = {
	cancel_reason: '',
	dept: '',
	display: 'none',
	from_date: '',
	loc: '',
	message: '',
	nurse: '',
	org: '',
	page_no: 1,
	role: '',
	shift_id: '',
	shift_status: '',
	sort: 'date',
	sort_ndp: 0,
	sortOrder: 'desc',
	statcash: '',
	supervisor_id: '',
	supervisorList: [],
	timesheetList: {},
	timezone: '',
	to_date: ''
};

export default handleActions(
	{
		RESET_TIMESHEETS: () => initialState,
		SET_DEPT_FILTER: (state, action) => ({ ...state, dept: action.payload }),
		SET_FORM_DATE_FILTER: (state, action) => ({ ...state, from_date: action.payload }),
		SET_LOC_FILTER: (state, action) => ({ ...state, loc: action.payload }),
		SET_MESSAGE: (state, action) => ({ ...state, message: action.payload }),
		SET_ORG_FILTER: (state, action) => ({ ...state, org: action.payload }),
		SET_ROLE_FILTER: (state, action) => ({ ...state, role: action.payload }),
		SET_SHIFT_PAGE_NUMBER: (state, action) => ({ ...state, page_no: action.payload }),
		SET_SHIFT_STATUS_FILTER: (state, action) => ({ ...state, shift_status: action.payload }),
		SET_SORT: (state, action) => ({ ...state, sort: action.payload }),
		SET_SORT_NDP: (state, action) => ({ ...state, sort_ndp: action.payload }),
		SET_SORT_ORDER: (state, action) => ({ ...state, sortOrder: action.payload }),
		SET_STATCash_FILTER: (state, action) => ({ ...state, statcash: action.payload }),
		SET_SUPERVISOR_LIST: (state, action) => ({ ...state, supervisorList: action.payload }),
		SET_SUPREVISOR_ID_FILTER: (state, action) => ({ ...state, supervisor_id: action.payload }),
		SET_TIMESHEET_DISPLAY_STATE: (state, action) => ({ ...state, display: action.payload }),
		SET_TIMESHEET_NURSE: (state, action) => ({ ...state, nurse: action.payload }),
		SET_TIMESHEET_SHIFT_ID: (state, action) => ({ ...state, shift_id: action.payload }),
		SET_TIMESHEET_TIMEZONE: (state, action) => ({ ...state, timezone: action.payload }),
		SET_TIMESHEETS: (state, action) => ({ ...state, timesheetList: action.payload }),
		SET_TO_CANCEL_REASON_FILTER: (state, action) => ({ ...state, cancel_reason: action.payload }),
		SET_TO_DATE_FILTER: (state, action) => ({ ...state, to_date: action.payload })
	},
	initialState
);

export const clearAllTimesheetValues = () => {
	return function (dispatch) {
		dispatch(setOrgFilter(''));
		dispatch(setStatusFilter(''));
		dispatch(setLocFilter(''));
		dispatch(setRoleFilter(''));
		dispatch(setFromDateFilter(''));
		dispatch(setToDateFilter(''));
		dispatch(setSupervisorIdFilter(''));
		dispatch(setDeptFilter(''));
		dispatch(setCancelReason(''));
		dispatch(setShiftIdFilter(''));
		dispatch(setTimesheetNurseFilter(''));
		dispatch(setTimesheetTimeZoneFilter(''));
		dispatch(setSort_ndp(0));
	};
};

export const setPageNumber = (pageNo, val) => {
	return function (dispatch) {
		dispatch(setShiftPageNumber(pageNo));
		if (val === true) {
			dispatch(getNotCheckinTimesheet());
		} else {
			dispatch(getTimesheetsWithPaging());
		}
	};
};

export const getTimesheetsWithPaging = () => {
	return function (dispatch, getState) {
		dispatch(setTimesheetList([]));
		dispatch(setTimesheetDisplayState('block'));

		Agent.getTimesheetsWithPaging(getState().adminTimesheets).then((response) => {
			if (response.ok) {
				dispatch(setTimesheetList(response.data));
			} else {
				dispatch(handleError(response));
			}

			dispatch(setTimesheetDisplayState('none'));
		});
	};
};

// Calling get timesheets api without refreshing the complete page as in above function.
// With above function it was refreshing and setting 'View STATCash Timesheets' check value off every time.
export const getTimesheetsWithoutPaging = () => {
	return function (dispatch, getState) {
		Agent.getTimesheetsWithPaging(getState().adminTimesheets).then((response) => {
			if (response.ok) {
				dispatch(setTimesheetList(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const loadSupervisorList = () => {
	return function (dispatch, getState) {
		Agent.supervisors(
			getState().adminTimesheets.org != '' ? getState().adminTimesheets.org : 'NA',
			getState().adminTimesheets.loc != '' ? getState().adminTimesheets.loc : 'NA'
		).then((response) => {
			if (response.ok) {
				dispatch(setSupervisorList(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

// Add note api call
export const addComment = (timesheet_id, message_type) => {
	return function (dispatch, getState) {
		const { message } = getState().adminTimesheets;

		Agent.addComments(timesheet_id, message, message_type).then((response) => {
			if (response.ok) {
				dispatch(setMessage(''));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

// Mark timesheet as paid api call
export const markTimesheetAsPaid = (id) => {
	return function (dispatch) {
		let checkinDateTime = null;
		let checkoutDateTime = null;

		Agent.markAsPaid(id, checkinDateTime, checkoutDateTime).then((response) => {
			if (response.ok) {
				dispatch(getTimesheetsWithPaging());
				mixpanel.track(mixpanelConstants.MARK_TIMESHEET_AS_PAID, {
					timesheetId: id,
					timesheetStatus: timesheetConstants.PAID
				});
			} else {
				alert(response.data);
				dispatch(handleError(response));
			}
		});
	};
};

export const getNotCheckinTimesheet = () => {
	return function (dispatch, getState) {
		dispatch(setTimesheetList([]));
		dispatch(setTimesheetDisplayState('block'));

		Agent.getNotCheckinTimesheet(getState().adminTimesheets).then((response) => {
			if (response.ok) {
				dispatch(setTimesheetList(response.data));
			} else {
				dispatch(handleError(response));
			}

			dispatch(setTimesheetDisplayState('none'));
		});
	};
};
